import {defineStore} from "pinia";
import {getUserDetailsApi, login} from "@/api/authApi";
import {setAuthorizationToken} from "@/axios";
import {showError} from "../services/alertService";
import {useCartStore} from "./cartStore";

export const useAuthStore = defineStore("authStore", {
  state: () => ({
    user: null,
    userDetails: null,
  }),

  getters: {
    isLogined(store) {
      return !!store.user;
    },

    getUser(store) {
      return store.user;
    },

    getUserDetails(store) {
      return {
        ...store.userDetails,
        firstName: "not ready yet",
        lastName: "not ready yet",
        birthDate: "not ready yet",
        gender: "not ready yet",
      };
    },
  },

  actions: {
    async login(credentials) {
      try {
        const user = await login(credentials);
        this.setUser(user);
        useCartStore().syncCarts();
      } catch (error) {
        throw error;
      }
    },

    async loginMobileApp() {
      if (!window.MobileApp) return;

      const credentialsData = window.MobileApp.getAuthData();
      const credentials = JSON.parse(credentialsData);
      // alert(`login: ${credentials.userLogin} | pass: ${credentials.userPass}`);

      await this.login(credentials);
    },

    async loadUserDetails() {
      try {
        this.userDetails = await getUserDetailsApi();
      } catch (error) {
        showError(error.message);
      }
    },

    setUser(user) {
      this.user = user;
      localStorage.setItem("user", JSON.stringify(user));
      setAuthorizationToken(user.jwt);
      this.loadUserDetails();
    },

    async logout() {
      localStorage.removeItem("user");
      await this.loginMobileApp();
      location.reload();
    },
  },
});
